import React, { createContext, useContext, useMemo } from "react";

const {
  getDefaultBrand,
  getBrandByKey,
  resolveBrandFromHostname,
} = require("../../../shared/branding");

const BrandContext = createContext(getDefaultBrand());

function resolveInitialBrand({ brand, brandKey, hostname } = {}) {
  if (brand?.brandKey) {
    return getBrandByKey(brand.brandKey);
  }

  if (brandKey) {
    return getBrandByKey(brandKey);
  }

  if (hostname) {
    return resolveBrandFromHostname(hostname);
  }

  if (typeof window !== "undefined") {
    return resolveBrandFromHostname(window.location.hostname);
  }

  return getDefaultBrand();
}

export function BrandProvider({ children, brand, brandKey, hostname }) {
  const value = useMemo(
    () => resolveInitialBrand({ brand, brandKey, hostname }),
    [brand, brandKey, hostname]
  );

  return <BrandContext.Provider value={value}>{children}</BrandContext.Provider>;
}

export function useBrand() {
  return useContext(BrandContext);
}

